// extracted by mini-css-extract-plugin
module.exports = {"modelItem":"modelItem--3b7mr","tableCell":"tableCell--2gaaK","action":"action--a9uEF","deleteButton":"deleteButton--13f2P","updateButton":"updateButton--86AQ0"};